import { Toast } from 'vant'
import NavBar from '@/components/Nav.vue';

import enums from '@/configs/enums.js';
import client from '@/configs/client.js';

export default {
    name: 'PaymentPage',
    components: {
        NavBar,
    },
    data() {
        return {
            timer: null,
            states: enums.orderState
        }
    },
    created() {
        // 判断在端内还是端外
        if (client.xinhua) {
            this.$http.get('order/' + this.$route.params.id + '/queryOrder').then(result => {
                let data = {
                    uuid: result.data.productNumber,
                    priceId: result.data.priceId,
                    type: 12,
                    orderId: result.data.orderNumber
                }
                if (client.ios) {
                    window.webkit.messageHandlers.goPayPage.postMessage(data);
                } else {
                    /* eslint-disable */
                    xinhuanet.goPayPage(JSON.stringify(data));
                    /* eslint-enable */
                }
                this.$route.back();
            });
        } else {
            // 端外第三方支付有回跳，所以通过back参数判断是否为再次进入
            if (! this.$route.query.back) {
                this.$http.get('order/' + this.$route.params.id + '/cashier').then(result => {
                    location.replace(result.data.url);
                });
            } else {
                this.setCheck();
            }
        }
    },
    unmounted() {
        clearInterval(this.timer);
    },
    methods: {
        setCheck() {
            // 检测订单结果
            this.timer = setInterval(() => {
                this.$http.get('order/' + this.$route.params.id + '/check').then(result => {
                    if (result.data.state != this.states.waiting) {
                        Toast(result.data.state == this.states.complete ? '支付成功' : '订单已关闭');
                        this.$router.replace('/');
                    }
                })
            }, 1000);
        }
    }
}